import crsLogo from '../../assets/crsLogo.png';
import jizhang from '../../assets/jizhang.png';
import beian from '../../assets/beian.png';
import cloudpark from '../../assets/cloud-park.png';

export const requirementDatasource = {
    BK: [
        {
            img: cloudpark,
            title: '云上公司注册',
            des: '支持异地远程注册，送注册地址，享园区政策扶持',
            price: '1',
            link: 'park',
            url: '/product/cbs#/park'
        },
        {
            img: crsLogo,
            title: '工商注册服务',
            des: '工商专家为您省心办理，无隐形收费',
            price: '9.9',
            link: 'crs',
            url: '/product/crs#/'
        },
        {
            img: beian,
            title: 'ICP许可证',
            des: '经营性网站必备资质，助力企业合法合规经营',
            price: '1200',
            link: 'bla',
            url: '/product/bla'
        }
    ],
    CRS: [
        {
            img: cloudpark,
            title: '云上公司注册',
            des: '支持异地远程注册，送注册地址，享园区政策扶持',
            price: '1',
            link: 'park',
            url: '/product/cbs#/park'
        },
        {
            img: jizhang,
            title: '代理记账服务',
            des: '云会计代理记账，品质服务，安心代账',
            price: '1199',
            link: 'bookkeeping',
            url: '/product/bookkeeping#/'
        },
        {
            img: beian,
            title: 'ICP许可证',
            des: '经营性网站必备资质，助力企业合法合规经营',
            price: '1200',
            link: 'bla',
            url: '/product/bla'
        }
    ]
};

export const productIntroTabSource = {
    BKP: [
        {
            text: '服务介绍',
            value: 'intro'
        },
        {
            text: '服务内容',
            value: 'serviceContent'
        },
        {
            text: '服务优势',
            value: 'advantage'
        },
        {
            text: '办理流程',
            value: 'process'
        },
        {
            text: '准备材料',
            value: 'materails'
        },
        {
            text: '常见问题',
            value: 'problem'
        }
    ],
    BLA: [
        {
            text: '服务介绍',
            value: 'intro'
        },
        {
            text: '服务优势',
            value: 'advantage'
        },
        {
            text: '办理流程',
            value: 'process'
        },
        {
            text: '准备材料',
            value: 'materails'
        },
        {
            text: '常见问题',
            value: 'problem'
        }
    ],
    BK: [
        {
            text: '服务介绍',
            value: 'intro'
        },
        {
            text: '服务内容',
            value: 'serviceContent'
        },
        {
            text: '服务优势',
            value: 'advantage'
        },
        {
            text: '办理流程',
            value: 'process'
        },
        {
            text: '准备材料',
            value: 'materails'
        },
        {
            text: '常见问题',
            value: 'problem'
        }
    ],
    CRS: [
        {
            text: '服务介绍',
            value: 'intro'
        },
        {
            text: '服务优势',
            value: 'advantage'
        },
        {
            text: '服务流程',
            value: 'process'
        },
        {
            text: '办理材料',
            value: 'materails'
        },
        {
            text: '常见问题',
            value: 'problem'
        }
    ],
    TMS: [
        {
            text: '服务介绍',
            value: 'intro'
        },
        {
            text: '服务优势',
            value: 'advantage'
        },
        {
            text: '办理流程',
            value: 'process'
        },
        {
            text: '准备材料',
            value: 'materails'
        },
        {
            text: '常见问题',
            value: 'problem'
        }
    ]
};

export const agreementSource = {
    BK: {
        text: '《百度智能云代理记账用户服务协议》',
        link: 'https://cloud.baidu.com/doc/CBS/s/8kno0p6fi'
    },
    CRS: {
        text: '《百度智能云工商注册服务协议》',
        link: 'https://cloud.baidu.com/doc/CBS/s/skj9vos8w'
    }
};

export const formDataValidConfig = {
    comName: value => {
        if (value === '') {
            return '请输入公司名称';
        }
        if (!/[\u4e00-\u9fa5]+/g.test(value)) {
            return '请输入中文公司名称';
        }
    },
    phone: value => {
        if (value === '') {
            return '请输入联系电话';
        }
        if (!/^1[0-9]{10}$/.test(value)) {
            return '联系电话格式错误';
        }
    },
    smsCode: value => {
        if (value === '') {
            return '请输入验证码';
        }
        if (!/^[0-9]{6}$/.test(value)) {
            return '验证码格式错误';
        }
    },
    description: value => {
        if (value.length > 1024) {
            return '最多输入1024个字';
        }
    }
};
